import styles from './termos.module.css';

function Termos() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Termos de Serviço</h1>
        <p>Transparência total em cada etapa da sua compra.</p>
      </header>

      <main className={styles.content}>
        <section>
          <h2>1. Cadastro e Dados</h2>
          <p>
            Ao realizar um pedido, você concorda em fornecer informações precisas e atualizadas 
            (Nome, CPF, E-mail, Telefone e Endereço). Estes dados são essenciais para a 
            emissão da nota fiscal e a logística de entrega.
          </p>
        </section>

        <section>
          <h2>2. Pagamentos e Segurança</h2>
          <p>
            Todas as transações financeiras são processadas pela <strong>InfinitePay</strong>. 
            Nossa loja não tem acesso aos seus dados de cartão ou detalhes bancários, garantindo 
            uma camada extra de proteção via criptografia da plataforma de pagamento.
          </p>
        </section>

        <section>
          <h2>3. Envios e Logística</h2>
          <p>
            Nossas entregas são intermediadas pelo <strong>Melhor Envio</strong>. 
            O prazo de entrega começa a contar a partir da confirmação do pagamento e pode 
            variar conforme a transportadora selecionada no checkout.
          </p>
        </section>

        <section className={styles.highlight}>
          <h2>4. Trocas, Devoluções e Reembolsos</h2>
          <p>
            Respeitamos o seu direito de arrependimento (7 dias corridos após o recebimento). 
            Contudo, para garantir agilidade e um atendimento personalizado:
          </p>
          <div className={styles.whatsappNotice}>
            <strong>Atenção:</strong> Toda e qualquer questão envolvendo a devolução de itens 
            ou estorno de valores deve ser tratada <strong>diretamente com o lojista via WhatsApp</strong>.
          </div>
          <p>
            Não iniciamos processos de logística reversa ou reembolso sem o contato prévio 
            por este canal, onde forneceremos todas as instruções necessárias.
          </p>
        </section>

        <section>
          <h2>5. Responsabilidades</h2>
          <p>
            A loja se compromete a enviar os produtos conforme descrito. Não nos responsabilizamos 
            por mau uso dos itens ou por atrasos exclusivos das transportadoras após a postagem 
            feita via Melhor Envio.
          </p>
        </section>
      </main>

      <footer className={styles.footer}>
        <p>Ao navegar e comprar, você concorda com estes termos.</p>
        <p>Última atualização: Março de 2026</p>
      </footer>
    </div>
  );
}

export default Termos;